import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { Info } from "lucide-react";
import React from "react";

interface JFrogTokenReferenceCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export function JFrogTokenReferenceCheckbox({
  checked,
  onCheckedChange,
  disabled,
  className,
}: JFrogTokenReferenceCheckboxProps) {
  const checkboxId = React.useId();

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Checkbox
        id={checkboxId}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(next) => onCheckedChange(next === true)}
      />
      <Label htmlFor={checkboxId} className="text-sm font-normal">
        Create a reference token
      </Label>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className="text-muted-foreground" aria-label="About reference tokens">
            <Info className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          Also generate a short reference token for Docker and Helm login. JFrog recommends this over API keys. The full
          access token is still shown once.
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
